export const TermOfUseLink = "https://www.q4inc.com/maindisclaimer/";
export const PrivacyLink = "https://www.q4inc.com/privacy-center/default.aspx";
